import { render, staticRenderFns } from "./AdminHospitalAdd.vue?vue&type=template&id=20e23228"
import script from "./AdminHospitalAdd.vue?vue&type=script&lang=js"
export * from "./AdminHospitalAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports